module.exports = __webpack_public_path__ + "static/process6-a073e33a6f0e54b8ff9111a9a4b6abe4.png";